import { IUpdateLeadDataDto } from "../../../../services/caju/salesForce/iUpdateLeadDataDto";
import { IStep3FormValues } from "../useStep3Form/iStep3FormValues";

export function getDtoFromStep3FormValues(
  leadId: string,
  values: IStep3FormValues
) {
  const result: IUpdateLeadDataDto = {
    ExternalId__c: leadId,
    step__c: 3,
    products__c: values.products.join(";"),
    LastContactDate__c: new Date().toJSON(),
  };

  return result;
}
